import {
  FileUploader,
  FileUploaderHeader
} from '@library/components/modals/FileUploaderModal';
import { CloseModalButton } from '@library/components/buttons';
import type { ImageFileTypes } from '@library/types/polls';
import { Modal } from '@library/components/modals/Modal';
import type { QueryMutationError } from '@bo-types/common';

export interface FileUploaderModalProps {
  additionalMessageInfo?: string;
  active: boolean;
  fileType?: 'csv' | ImageFileTypes;
  onCancelModal: () => void;
  onFileUpload: (files: File | null) => void;
  isCorrelations?: boolean;
  isUploadError: boolean;
  isUploading: boolean;
  isUploadSuccess: boolean;
  loadingMessage?: string;
  resetUploadAPI: () => void;
  uploadError: QueryMutationError;
}

export const FileUploaderModal = ({
  additionalMessageInfo = '',
  active,
  fileType = 'csv',
  isCorrelations = false,
  isUploadError,
  isUploading,
  isUploadSuccess,
  loadingMessage = '',
  onCancelModal,
  onFileUpload,
  resetUploadAPI,
  uploadError
}: FileUploaderModalProps) => {
  if (!active) {
    return null;
  }

  return (
    <Modal isOpen={active} onCancelModal={onCancelModal}>
      <div className="border-soFresh-140 bg-soFresh-110 text-soClean-100 w-screen max-w-screen-sm rounded-lg border shadow-lg">
        <div className="flex h-16 items-start justify-between border-b border-inherit">
          <FileUploaderHeader fileType={fileType} />
          <CloseModalButton handleOnClick={onCancelModal} />
        </div>
        <FileUploader
          additionalMessageInfo={additionalMessageInfo}
          className="flex flex-col gap-4 p-6"
          fileType={fileType}
          isCorrelations={isCorrelations}
          isUploadError={isUploadError}
          isUploading={isUploading}
          isUploadSuccess={isUploadSuccess}
          loadingMessage={loadingMessage}
          onCancel={onCancelModal}
          onFileUpload={onFileUpload}
          resetUploadAPI={resetUploadAPI}
          uploadError={uploadError}
        />
      </div>
    </Modal>
  );
};
